/**
 * 404 Not Found Page
 *
 * Displayed when user navigates to a non-existent route
 */
import { Button, Result } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeOutlined, HistoryOutlined } from '@ant-design/icons';
import { logger } from '@/shared/utils/logger';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Log 404 for debugging
  logger.warn('404 Page Not Found', { path: location.pathname });

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '24px',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you are looking for does not exist or has not been developed yet."
        extra={[
          <Button
            type="primary"
            key="home"
            icon={<HomeOutlined />}
            onClick={handleGoHome}
          >
            Go Home
          </Button>,
          <Button key="back" icon={<HistoryOutlined />} onClick={handleGoBack}>
            Go Back
          </Button>,
        ]}
      />
    </div>
  );
};

export default NotFoundPage;
